var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72386 2.66659H4V1.33325H9.72386C10.0775 1.33325 10.4166 1.47373 10.6667 1.72378L13.6095 4.66659C13.8595 4.91663 14 5.25577 14 5.60939V12.6666H12.6667V5.60939L9.72386 2.66659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.66659C2 3.93021 2.59695 3.33325 3.33333 3.33325H8.74257C9.10034 3.33325 9.4431 3.47703 9.6938 3.73227L11.6179 5.69119C11.8628 5.94052 12 6.27603 12 6.62551V13.3333C12 14.0696 11.403 14.6666 10.6667 14.6666H3.33333C2.59695 14.6666 2 14.0696 2 13.3333V4.66659ZM7.33333 4.66659H3.33333V13.3333H10.6667V7.99992H7.33333V4.66659ZM8.66667 4.66659V6.66659H10.6667V6.62551L8.74257 4.66659H8.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.4d0410994a75a8b1dbb266bb2db55a93.svg";
export { ForwardRef as ReactComponent };